import { z } from 'zod';

// PASSTHROUGH: fornitore esterno (Twilio) aggiunge campi senza preavviso.
// MAI usare .strict() qui — bloccherebbe nuove versioni del payload Twilio.
export const twilioIncomingMessageWebhookSchema = z.object({
  MessageSid: z.string().min(1).optional(),
  SmsSid: z.string().optional(),
  AccountSid: z.string().optional(),
  From: z.string().optional(),
  To: z.string().optional(),
  Body: z.string().optional(),
  NumMedia: z.string().optional(),
  ProfileName: z.string().optional(),
  WaId: z.string().optional(),
}).passthrough();

export const twilioStatusCallbackSchema = z.object({
  MessageSid: z.string().optional(),
  MessageStatus: z.string().optional(),
  SmsSid: z.string().optional(),
  SmsStatus: z.string().optional(),
  AccountSid: z.string().optional(),
  ErrorCode: z.string().optional(),
  ErrorMessage: z.string().optional(),
  From: z.string().optional(),
  To: z.string().optional(),
}).passthrough();

export const twilioVoiceStatusCallbackSchema = z.object({
  CallSid: z.string().optional(),
  CallStatus: z.string().optional(),
  AccountSid: z.string().optional(),
  From: z.string().optional(),
  To: z.string().optional(),
  Direction: z.string().optional(),
}).passthrough();
